var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookedSlotMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7640",
    "data-name": "Group 7640",
    transform: "translate(12768 -10190)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22850",
    "data-name": "Ellipse 22850",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(-12768 10190)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M10.912,4.24a.841.841,0,0,1,.878-.589h.216a.926.926,0,0,1,.866.865l.938,7.369a.964.964,0,0,1-1.923.144l-.6-4.652L9.469,11.115a1.2,1.2,0,0,1-1.07.769,1.2,1.2,0,0,1-1.058-.805l-1.827-3.7-.553,4.7a.938.938,0,0,1-1.034.817.926.926,0,0,1-.878-.962l.9-7.417a.938.938,0,0,1,.841-.865h.192a.829.829,0,0,1,.878.589L8.4,9.589Z",
    transform: "translate(-12768.431 10189.322)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookedSlotMember);
export default __webpack_public_path__ + "static/media/booked-slot-member.cf08d15883ad11ef45909cc4e8744d66.svg";
export { ForwardRef as ReactComponent };